import vdhgsmi from "../../../../assets/images/productos/vdhgsmi/VDHGSMI.png";
import qr from "../../../../assets/images/QR Fabian Llamazares.svg";
import Producto from "../../../../components/producto";
import pic1 from "../../../../assets/images/productos/vdhgsmi/Mosaico - GSMI1.png";
import pic2 from "../../../../assets/images/productos/vdhgsmi/Mosaico - GSMI2.png";

import { useTranslation } from "react-i18next";

function VDHGSMI() {
  const { t } = useTranslation();

  return (
    <Producto
      fotos={[pic1, pic2]}
      datosTabla1={[
        [t("modelo"), "", "Circuit Breaker", "Grounding Switch"],
        [t("tensionMaximaDeServicio"), "kV", "38", "38"],
        [t("corrienteNominal"), "A", "1.200 / 2.000", "-"],
        [t("capacidadDeCierreNominal"), "kA", "25 / 31,5 / 40", "-"],
        [t("corrienteBreveDuracion"), "kA (3sec)", "25 / 31,5 / 40", "12,5"],
        [
          t("corrienteNominalCierreEnclavamiento"),
          "kA",
          "65 / 82 / 104",
          "33",
        ],
        [t("rigidezDielectrica"), "kV", "80", "80"],
        [t("rigidezDielectricaImpulso"), "kV", "200", "200"],
        [t("frecuenciaNominal"), "Hz", "50/60", "50/60"],
        [t("tiempoDeCierreNominal"), "msec", "< 45", "-"],
        [t("tiempoDeAperturaNominal"), "msec", "< 30", "-"],
        [t("tiempoDeArcoNominal"), "msec", "4/11", "-"],
        [t("conmutacionMecanica"), "msec", "12/16", "-"],
        [t("conmutacionElectrica"), "msec", "12", "12"],
      ]}
      datosTabla2={[
        [t("ancho"), "mm", "1.800"],
        [t("alto"), "mm", "3.255 / 3.755"],
        [t("profundidad"), "mm", "1.800"],
      ]}
      nombreProducto={"VDH/GSMI"}
      fotoProducto={vdhgsmi}
      descripcionProducto={t("vdh-gsmi.titulo_descripcion")}
      caracteristicas={[
        t("vdh-gsmi.bullet1"),
        t("vdh-gsmi.bullet2"),
        t("vdh-gsmi.bullet3"),
        t("vdh-gsmi.bullet4"),
        t("vdh-gsmi.bullet5")
      ]}
      vendedor={{
        nombre: "Fabian Llamazares",
        telefono: "+54 9 11 5096-3680",
        mail: "fllamazares@ema.com.ar",
        qr: qr,
      }}
      pathPdf={"/assets/docs/2025%20-%20VDH%20GSMI%20USA.pdf"}
    />
  );
}

export default VDHGSMI;
